export default __webpack_public_path__ + "static/media/duo-violin-e-cello.d4d9f831.png";